import { FormControlLabel, Radio, Typography, useTheme } from "@mui/material";
import { ReactNode } from "react";
import { radioAccentColor } from "../../ipPortalTheme";

export interface DotLegalRadioButtonProps {
    value: unknown;
    label?: string;
    labelNode?: ReactNode;
    disabled?: boolean;
    labelPlacement?: "start" | "end" | "top" | "bottom";
    smallSideMargin?: boolean;
    fontSize?: "xs" | "s" | "m" | "l" | "xl";
}

function getFontSize(fontSize: DotLegalRadioButtonProps["fontSize"], pxToRem: (size: number) => string) {
    switch (fontSize) {
        case "xs":
            return pxToRem(10);
        case "s":
            return pxToRem(12);
        case "l":
            return pxToRem(16);
        case "xl":
            return pxToRem(18);
        default:
            return pxToRem(14);
    }
}

// Ported from @dotlegal/dotlegal-ui-components' DotLegalRadioButton, which hardcoded its color to
// theme.palette.secondary.main (kept pale for other uses) with no way to override it per-instance.
// Owning the component locally lets it use the brand accent color directly and lets us gradually
// drop the dependency on that shared package.
function DotLegalRadioButton(props: DotLegalRadioButtonProps) {
    const theme = useTheme();

    return (
        <FormControlLabel
            sx={{
                marginLeft: props.smallSideMargin ? "8px !important" : "",
                marginRight: props.smallSideMargin ? "8px !important" : "",
            }}
            className="pdfRadioButton"
            disabled={props.disabled}
            value={props.value}
            labelPlacement={props.labelPlacement ?? "end"}
            control={
                <Radio
                    sx={{
                        "& svg": {
                            fill: props.disabled ? theme.palette.text.disabled : radioAccentColor,
                        },
                    }}
                    disabled={props.disabled}
                    size="small"
                />
            }
            label={
                props.labelNode ?? (
                    <Typography
                        sx={{
                            fontSize: getFontSize(props.fontSize, theme.typography.pxToRem),
                            color: props.disabled ? theme.palette.text.disabled : theme.palette.primary.dark,
                        }}
                    >
                        {props.label}
                    </Typography>
                )
            }
        />
    );
}

export default DotLegalRadioButton;
